"use strict"

class ToggleTable {
	constructor ( buttonOpeningTable, buttonClosingTable, tableContainer ) {
		this.buttonOpening = buttonOpeningTable;
		this.buttonClosing = buttonClosingTable;
		this.tableContainer = tableContainer;

		this.bindUIActions();
	}

	/**
	 * @function bindUIActions
	 * @desc Bind an event listener on the button and init the behaviours of the region and the button
	 */
	bindUIActions () {
		this.buttonOpening.addEventListener( 'click', this.openTableContainer.bind(this) );
		this.buttonClosing.addEventListener( 'click', this.closeTableContainer.bind(this) );
	}

	openTableContainer () {
		// We hide the currently displayed table if there's one and show its linked button
		let currentTableButton = document.querySelector('.js-corporate-table-opening.is-hidden');
		let currentTableWrapper = document.querySelector('.js-corporate-table.is-opened');
		if ( currentTableButton ) currentTableButton.classList.remove('is-hidden');
		if ( currentTableWrapper ) currentTableWrapper.classList.remove('is-opened');
		// We display the chosen table and hide its linked button
		this.buttonOpening.classList.add('is-hidden');
		this.tableContainer.classList.add('is-opened');
	}

	closeTableContainer () {
		this.buttonOpening.classList.remove('is-hidden');
		this.tableContainer.classList.remove('is-opened');
	}
}

export { ToggleTable }
